/* jshint esversion: 6 */
import Vue from 'vue';
import Router from 'vue-router';


import Main from '@/views/main';
import HelloWorld from '@/views/HelloWorld';

import Welcome from './welcome';
import Billing from './billing';
import PUE from './pue';
import EquipmentInOut from './equipment_in_out'
import knowledge from './knowledge';
import html from './html'
import workorder from './workorder'
import review from './review'
import kpi from './kpi'
import duty from './duty'
import notice from './notice'
import equipment from './equipment'

import assessment from './assessment'

import entranceGuard from './entrance_guard'
import board from "./board";

import ticket from '@/router/ticket'

import locations from './locations'
import dcim from './dcim'

import register from './register'
import workflow from './workflow'

import organization from './organization'

Vue.use(Router);

export default new Router({
  routes: [
    Welcome,
    {
      path: '/',
      name: 'Main',
      component: Main,
      children:[
          ...Billing,
          ...PUE,
          ...EquipmentInOut,
          ...PUE,
          ...knowledge,
          ...html,
          ...workorder,
          ...review,
          ...kpi,
          ...duty,
          ...assessment,
          ...entranceGuard,
          ...notice,
          ...board,
          ...ticket,
          ...equipment,
          ...dcim,
          ...locations,
          ...register,
          ...workflow,
          {
              path: '/index',
              component: () => import('@/views/index/index'),
          },
          ...organization,
      ]
    },
      {
          path: '/largeScreen',
          name: 'largeScreen',
          component: () => import('@/views/largeScreen/large-screen'),
      },
    {
      path: '/hello-vue',
      name: 'HelloWorld',
      component: HelloWorld
    },
    {
      path: '/noticeInfiniteScroll',
      component: () => import('@/views/notice/noticeInfiniteScroll'),
    },
    {
    	path: '/authorization',
      component: () => import('@/views/login/authorization'),
    },
    {
      name: '401',
      path: '/401',
      component: () => import('@/views/error-page/401.vue'),
      hidden: true,
    },
    { path: '/:pathMatch(.*)*', component: () => import('@/views/error-page/404.vue'), hidden: true },
  ],
  base: process.env.VUE_APP_BASEPATH,
  mode: 'history'
});
